const formatErrorMessage = (error: string): string => {
  if (error.includes('GraphQL error')) {
    error = error.replace('GraphQL error', '');
  } else if (error.includes('ApolloError')) {
    error = error.replace('ApolloError', '');
  } else if (error.includes('Network Error')) {
    error = error.replace('Network Error', '');
  } else if (error.includes('AxiosError')) {
    error = error.replace('AxiosError', '');
  }

  return error;
};

export default formatErrorMessage;
